import { useAuthStore } from '../stores/authStore';

/**
 * Whether the signed-in person can do something in the open workspace.
 *
 * Capability names and what they cover are defined in backend/src/lib/access.js,
 * and the server enforces them on every request. The UI only uses this to hide
 * controls that would be refused, so a guest is not offered what they cannot do.
 */
export function useCan(capability) {
  return useAuthStore((s) => !!s.user?.capabilities?.includes(capability));
}
